module.exports = __webpack_public_path__ + "img/plan4_book02.d5d2d227.png";